import { Result } from "antd";

const SecurityGate = ({ children, state }) => {
  const pathname = location.pathname;
  let securityPassed = true;

  const failCheck = () => (securityPassed = false);

  // TODO migrate security gate into JWT validation

  return securityPassed ? (
    children
  ) : (
    <Result
      status="403"
      subTitle="Sorry, you do not have access this page."
      title="403"
    />
  );
};

export default SecurityGate;
